// ** Import from react dom
import { Navigate, Route, Routes } from 'react-router-dom';

// ** Import core SCSS styles
import 'assets/scss/theme.scss';

// ** Import Layouts
import DashboardIndex from 'layouts/dashboard/DashboardIndex';
import AuthLayout from 'layouts/dashboard/AuthLayout';
// ** Import Dahbaord Menu Pages
import Overview from '../components/dashboard/overview/Overview';

// ** Import Courses Pages
// ** Import Users Pages
import Students from 'components/dashboard/students/all-students/Students';

// ** Import CMS Pages
// ** Import Authentication components
import SignIn from 'components/dashboard/authentication/SignIn';
import ForgetPassword from 'components/dashboard/authentication/ForgetPassword';

// ** Import InformationsScolaires components
// Dashboard Projects ( new v1.2.0 )
// Dashboard Apps -> Mail ( new v1.3.0 )
// Dashboard Apps -> Task Kanban ( v1.4.0 )
// ** Boostrap Forms components
// ** Boostrap components
// ** Import docs and change log pages
/* ----------------------------------- */
/* IMPORTS FOR MARKETING PAGES - START */
import NotFound from 'layouts/marketing/NotFound';

/* IMPORTS FOR FRONT SIDE PAGES MENU */
// IMPORTS FOR HELP CENTER PAGES ( v1.3.0 )
/* IMPORTS FOR FRONT BLOG SUBMENU  ROUTERS */
/* IMPORTS FOR FRONT CAREER SUBMENU  ROUTERS */
/* IMPORTS FOR FRONT SPECIALTY SUBMENU  ROUTERS */
import MaintenanceMode from 'components/marketing/pages/specialty/MaintenanceMode';

// Landing menu item pages
// Job Listing new pages ( v2.0.0 )
// Instructor Dashboard Pages
// Instructor New Dashboard Pages for Quiz ( v2.0.0)
// Student Dashboard Pages
// Student New Dashboard Pages for Quiz ( v2.0.0)
// Account InformationsScolaires
import AddNewStudent from '../components/dashboard/students/add-new-student/AddNewStudent';
import ViewStudent from '../components/dashboard/students/view-student/ViewStudent';
import DeleteStudent from '../components/dashboard/students/view-student/DeleteStudent';
import Parents from '../components/dashboard/parents/all-parents/Parents';
import ViewParent from '../components/dashboard/parents/view-parent/ViewParent';
import DeleteParent from '../components/dashboard/parents/view-parent/DeleteParent';
import ViewChildren from '../components/dashboard/parents/view-parent/ViewChildren';
import Budget from '../components/dashboard/budget/all-budget/Budget';
import ViewBudget from '../components/dashboard/budget/view-budget/ViewBudget';
import DeleteBudget from '../components/dashboard/budget/view-budget/DeleteBudget';
import Competence from '../components/dashboard/competences/all-competence/Competence';
import ViewCompetence from '../components/dashboard/competences/view-competence/ViewCompetence';
import DeleteCompetence from '../components/dashboard/competences/view-competence/DeleteCompetence';
import Salledeclasse from '../components/dashboard/salledeclasse/all-salledeclasse/Salledeclasse';
import ViewSalledeclasse from '../components/dashboard/salledeclasse/view-salledeclasse/ViewSalledeclasse';
import ViewEleves from '../components/dashboard/salledeclasse/view-salledeclasse/ViewEleves';
import Personnels from '../components/dashboard/personnel/all-personnels/Personnels';
import ViewPersonnel from '../components/dashboard/personnel/view-personnel/ViewPersonnel';
import DeletePersonnel from '../components/dashboard/personnel/view-personnel/DeletePersonnel';
import Contrat from '../components/dashboard/contrat/all-contrat/Contrat';
import ViewContrat from '../components/dashboard/personnel/view-personnel/ViewContrat';
import AccessGuard from '../components/dashboard/authentication/AccessGuard';
import Bulletinpaie from '../components/dashboard/bulletinpaie/all-bulletinpaie/Bulletinpaie';
import ViewBulletinpaie from '../components/dashboard/bulletinpaie/view-bulletinpaie/ViewBulletinpaie';
import InvoiceDetailsBulletinpaie from '../components/dashboard/bulletinpaie/view-bulletinpaie/InvoiceDetailsBulletinpaie';

import ViewEmprunt from '../components/dashboard/emprunts/view-emprunt/ViewEmprunt';
import DeleteEmprunt from '../components/dashboard/emprunts/view-emprunt/DeleteEmprunt';
import Materiels from '../components/dashboard/materiel/all-materiels/Materiels';
import ViewMateriel from '../components/dashboard/materiel/view-materiel/ViewMateriel';
import DeleteMateriel from '../components/dashboard/materiel/view-materiel/DeleteMateriel';
import Depenserecettes from '../components/dashboard/depenserecette/all-depenserecettes/Depenserecettes';
import ViewDepenserecette from '../components/dashboard/depenserecette/view-depenserecette/ViewDepenserecette';
import DeleteDepenserecette from '../components/dashboard/depenserecette/view-depenserecette/DeleteDepenserecette';
import Locals from '../components/dashboard/locals/all-local/Locals';
import ViewLocal from '../components/dashboard/locals/view-local/ViewLocal';
import DeleteLocal from '../components/dashboard/locals/view-local/DeleteLocal';
import ViewMatiere from '../components/dashboard/matiere/view-matiere/ViewMatiere';
import DeleteMatiere from '../components/dashboard/matiere/view-matiere/DeleteMatiere';
import TypeLocals from '../components/dashboard/typelocal/all-typelocals/TypeLocal';
import ViewTypeLocal from '../components/dashboard/typelocal/view-typelocal/ViewTypeLocal';
import DeleteTypeLocal from '../components/dashboard/typelocal/view-typelocal/DeleteTypeLocal';
import Emprunts from '../components/dashboard/emprunts/all-emprunts/Emprunts';
import ViewLivre from '../components/dashboard/livres/view-livre/ViewLivre';
import Livres from '../components/dashboard/livres/all-livres/Livres';
import DeleteLivre from '../components/dashboard/livres/view-livre/DeleteLivre';
import OldStudents from '../components/dashboard/archived_students/all-archived-students/OldStudents';
import ViewOldStudent from '../components/dashboard/archived_students/view-archived-student/ViewOldStudent';
import DeleteOldStudent from '../components/dashboard/archived_students/view-archived-student/DeleteOldStudent';
import ArchiveStudent from '../components/dashboard/students/view-student/ArchiveStudent';
import ArchivePersonnel from '../components/dashboard/personnel/view-personnel/ArchivePersonnel';
import DeleteOldPersonnel from '../components/dashboard/archived_personnel/view-archived-personnel/DeleteOldPersonnel';
import ViewOldPersonnel from '../components/dashboard/archived_personnel/view-archived-personnel/ViewOldPersonnel';
import OldPersonnels from '../components/dashboard/archived_personnel/all-archived-personnels/OldPersonnels';
import Matieres from '../components/dashboard/matiere/all-matieres/Matieres';
import Emploidutemps from '../components/dashboard/calendar/Calendar';
import Fraisscolarites from '../components/dashboard/fraisscolarite/all-fraisscolarites/Fraisscolarites';
import ViewFraisscolarite from '../components/dashboard/fraisscolarite/view-fraisscolarite/ViewFraisscolarite';
import DeleteFraisscolarite from '../components/dashboard/fraisscolarite/view-fraisscolarite/DeleteFraisscolarite';
import BulletinnotesClasses from '../components/dashboard/bulletinnotes/all-bulletinnotes/bulletins_classes/BulletinnotesClasses';
import Tenues from '../components/dashboard/tenues/all-tenues/Tenues';
import ViewTenue from '../components/dashboard/tenues/view-tenue/ViewTenue';
import DeleteTenue from '../components/dashboard/tenues/view-tenue/DeleteTenue';
import Maintenances from '../components/dashboard/maintenance/all-maintenance/Maintenances';
import ViewMaintenance from '../components/dashboard/maintenance/view-maintenance/ViewMaintenance';
import DeleteMaintenance from '../components/dashboard/maintenance/view-maintenance/DeleteMaintenance';
import UnarchivePersonnel from '../components/dashboard/archived_personnel/view-archived-personnel/UnarchivePersonnel';
import UnarchiveStudent from '../components/dashboard/archived_students/view-archived-student/UnarchiveStudent';
import BulletinnotesEleves from '../components/dashboard/bulletinnotes/all-bulletinnotes/bulletins_eleves/BulletinnotesEleves';
import ViewBulletinnote from '../components/dashboard/bulletinnotes/view-bulletinnote/ViewBulletinnote';
import InvoiceDetailsBulletinnote from '../components/dashboard/bulletinnotes/view-bulletinnote/InvoiceDetailsBulletinnote';
import Suivipaiements from '../components/dashboard/suivipaiement/all-suivipaiements/Suivipaiements';
import ViewSuivipaiement from '../components/dashboard/suivipaiement/view-suivipaiement/ViewSuivipaiement';
import ViewHistoriquepaiement from '../components/dashboard/suivipaiement/view-suivipaiement/ViewHistoriquepaiement';
import InvoiceDetailsListeEleves from '../components/dashboard/salledeclasse/view-salledeclasse/InvoiceDetailsListeEleves';
import DetailsBulletinAnnuel from '../components/dashboard/bulletinnotes/view-bulletinnote/bulletin-annuel/DetailsBulletinAnnuel';
import Utilisateurs from '../components/dashboard/utilisateurs/all-utilisateurs/Utilisateurs';
import ViewUtilisateur from '../components/dashboard/utilisateurs/view-utilisateur/ViewUtilisateur';
import DeleteUtilisateur from '../components/dashboard/utilisateurs/view-utilisateur/DeleteUtilisateur';
import ArchivedDetailsBulletinAnnuel from '../components/dashboard/archived_students/archived-bulletin-annuel/ArchivedDetailsBulletinAnnuel';

const ProtectedRoute = ({ element }) => {
	return <AccessGuard>{element}</AccessGuard>;
};

const AllRoutes = () => {
	return (
		<Routes>
			{/* Routes with AuthLayout */}
			<Route element={<AuthLayout />}>
				<Route path="/authentication/sign-in" element={<SignIn />} />
				<Route
					path="/authentication/forget-password"
					element={<ForgetPassword />}
				/>
			</Route>

			{/* Routes (DASHBOARD ROUTERS) with DashboardIndex */}
			<Route element={<ProtectedRoute element={<DashboardIndex />} />}>
				<Route path="/" element={<Overview />} />

				{/* ADMINISTRATION */}
				<Route
					path="//administration/utilisateurs"
					element={<Utilisateurs />}
				/>
				<Route
					path="//administration/utilisateurs/:id"
					element={<ViewUtilisateur />}
				/>
				<Route
					path="//administration/utilisateurs/:id/delete"
					element={<DeleteUtilisateur />}
				/>

				{/* ELEVES */}
				<Route path="/education/eleves" element={<Students />} />
				<Route
					path="/education/eleves/nouvel-eleve"
					element={<AddNewStudent />}
				/>
				<Route path="/education/eleves/:id" element={<ViewStudent />} />
				<Route
					path="/education/eleves/:id/delete"
					element={<DeleteStudent />}
				/>
				<Route
					path="/education/eleves/:id/archive"
					element={<ArchiveStudent />}
				/>

				{/* PARENTS */}
				<Route path="/education/parents" element={<Parents />} />
				<Route
					path="/education/parents/:id/eleves"
					element={<ViewChildren />}
				/>
				<Route path="/education/parents/:id" element={<ViewParent />} />
				<Route
					path="/education/parents/:id/delete"
					element={<DeleteParent />}
				/>

				{/* PERSONNELS */}
				<Route path="/administration/personnel" element={<Personnels />} />
				<Route
					path="/administration/personnel/:id"
					element={<ViewPersonnel />}
				/>
				<Route
					path="/administration/personnel/:id/contrat"
					element={<ViewContrat />}
				/>
				<Route
					path="/administration/personnel/:id/delete"
					element={<DeletePersonnel />}
				/>

				<Route
					path="/administration/personnel/:id/archive"
					element={<ArchivePersonnel />}
				/>

				{/* BUDGET */}
				<Route path="/finances/budget" element={<Budget />} />
				<Route path="/finances/budget/:id" element={<ViewBudget />} />
				<Route path="/finances/budget/:id/delete" element={<DeleteBudget />} />

				{/* CONTRAT */}
				<Route
					path="/administration/personnel/contrats"
					element={<Contrat />}
				/>

				{/* CONTRAT */}
				<Route
					path="/administration/personnel/salaires"
					element={<Bulletinpaie />}
				/>
				<Route
					path="/administration/personnel/salaires/:id"
					element={<ViewBulletinpaie />}
				/>

				<Route
					path="/administration/personnel/salaires/:id/print"
					element={<InvoiceDetailsBulletinpaie />}
				/>

				{/* SALLE DE CLASSE */}
				<Route path="/locaux/classes" element={<Salledeclasse />} />
				<Route path="/locaux/classes/:id" element={<ViewSalledeclasse />} />
				<Route path="/locaux/classes/:id/eleves" element={<ViewEleves />} />
				<Route
					path="/locaux/classes/:id/eleves/print"
					element={<InvoiceDetailsListeEleves />}
				/>

				{/* COMPETENCE */}
				<Route path="/pedagogie/competences" element={<Competence />} />
				<Route path="/pedagogie/competences/:id" element={<ViewCompetence />} />
				<Route
					path="/pedagogie/competences/:id/delete"
					element={<DeleteCompetence />}
				/>

				{/* LIVRES */}
				<Route path="/services/bibliotheque/catalogue" element={<Livres />} />
				<Route
					path="/services/bibliotheque/catalogue/:id"
					element={<ViewLivre />}
				/>
				<Route
					path="/services/bibliotheque/catalogue/:id/delete"
					element={<DeleteLivre />}
				/>

				{/* TYPELOCAL */}
				<Route path="/assets/typelocal" element={<TypeLocals />} />
				<Route path="/assets/typelocal/:id" element={<ViewTypeLocal />} />
				<Route
					path="/assets/typelocal/:id/delete"
					element={<DeleteTypeLocal />}
				/>

				{/* EMPRUNT */}
				<Route path="/services/bibliotheque/emprunts" element={<Emprunts />} />
				<Route
					path="/services/bibliotheque/emprunts/:id"
					element={<ViewEmprunt />}
				/>
				<Route
					path="/services/bibliotheque/emprunts/:id/delete"
					element={<DeleteEmprunt />}
				/>

				{/* MATERIEL */}
				<Route path="/assets/materiels" element={<Materiels />} />
				<Route path="/assets/materiels/:id" element={<ViewMateriel />} />
				<Route
					path="/assets/materiels/:id/delete"
					element={<DeleteMateriel />}
				/>

				{/* DEPENSERECETTE */}
				<Route path="/finances/bilan" element={<Depenserecettes />} />
				<Route path="/finances/bilan/:id" element={<ViewDepenserecette />} />
				<Route
					path="/finances/bilan/:id/delete"
					element={<DeleteDepenserecette />}
				/>

				{/* Local */}
				<Route path="/locaux/autres" element={<Locals />} />
				<Route path="/locaux/autres/:id" element={<ViewLocal />} />
				<Route path="/locaux/autres/:id/delete" element={<DeleteLocal />} />

				{/* MATIERE */}
				<Route path="/pedagogie/matieres" element={<Matieres />} />
				<Route path="/pedagogie/matieres/:id" element={<ViewMatiere />} />
				<Route
					path="/pedagogie/matieres/:id/delete"
					element={<DeleteMatiere />}
				/>

				{/* EMPLOI DE TEMPS */}
				<Route path="/pedagogie/planning" element={<Emploidutemps />} />

				{/* FRAIS SCOLARITE */}
				<Route path="/finances/scolarite" element={<Fraisscolarites />} />
				<Route
					path="/finances/scolarite/:id"
					element={<ViewFraisscolarite />}
				/>
				<Route
					path="/finances/scolarite/:id/delete"
					element={<DeleteFraisscolarite />}
				/>

				{/* SUIVI PAIEMENTS */}
				<Route
					path="/finances/scolarite/suivipaiement"
					element={<Suivipaiements />}
				/>
				<Route
					path="/finances/scolarite/suivipaiement/:id"
					element={<ViewSuivipaiement />}
				/>
				<Route
					path="/finances/scolarite/suivipaiement/:id/history"
					element={<ViewHistoriquepaiement />}
				/>

				{/* BULLETIN DE TRIMESTRIELS */}
				<Route path="/pedagogie/notes" element={<BulletinnotesClasses />} />
				<Route
					path="/pedagogie/notes/:id/eleves"
					element={<BulletinnotesEleves />}
				/>
				<Route
					path="/pedagogie/notes/:salledeclasseId/eleves/:eleveId/"
					element={<ViewBulletinnote />}
				/>
				<Route
					path="/pedagogie/notes/:salledeclasseId/eleves/:eleveId/print"
					element={<InvoiceDetailsBulletinnote />}
				/>

				{/* BULLETIN DE ANNUELS */}
				<Route
					path="/pedagogie/notes/:salledeclasseId/eleves/:eleveId/annual-report/print"
					element={<DetailsBulletinAnnuel />}
				/>

				{/* TENUE */}
				<Route path="/finances/tenues" element={<Tenues />} />
				<Route path="/finances/tenues/:id" element={<ViewTenue />} />
				<Route path="/finances/tenues/:id/delete" element={<DeleteTenue />} />

				{/* MAINTENANCE */}
				<Route path="/services/maintenance" element={<Maintenances />} />
				<Route path="/services/maintenance/:id" element={<ViewMaintenance />} />
				<Route
					path="/services/maintenance/:id/delete"
					element={<DeleteMaintenance />}
				/>

				{/* ANCIENS ELEVES */}
				<Route path="/archives/eleves" element={<OldStudents />} />
				<Route path="/archives/eleves/:id" element={<ViewOldStudent />} />
				<Route
					path="/archives/eleves/:id/annual-report/print"
					element={<ArchivedDetailsBulletinAnnuel />}
				/>
				<Route
					path="/archives/eleves/:id/delete"
					element={<DeleteOldStudent />}
				/>
				<Route
					path="/archives/eleves/:id/unarchive"
					element={<UnarchiveStudent />}
				/>

				{/* ANCIENS PERSONNELS */}
				<Route path="/archives/personnel" element={<OldPersonnels />} />
				<Route path="/archives/personnel/:id" element={<ViewOldPersonnel />} />
				<Route
					path="/archives/personnel/:id/delete"
					element={<DeleteOldPersonnel />}
				/>
				<Route
					path="/archives/personnel/:id/unarchive"
					element={<UnarchivePersonnel />}
				/>
			</Route>

			{/* Routes with NotFound */}
			<Route element={<NotFound />}>
				<Route
					path="/marketing/specialty/maintenance-mode/"
					element={<MaintenanceMode />}
				/>
			</Route>

			{/*Redirect*/}
			<Route
				path="*"
				element={
					<Navigate to="/marketing/specialty/maintenance-mode/" replace />
				}
			/>
		</Routes>
	);
};

export default AllRoutes;
